// extracted by mini-css-extract-plugin
export default {"statusDiv":"task-status_statusDiv__kFlV+","p":"task-status_p__mktwt"};